import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NetworkService } from 'src/app/services/network.service';

@Injectable()
export class ConditionalInterceptor implements HttpInterceptor {

    constructor(private router: Router, private networkService: NetworkService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const currentUrl = this.router.url;
        const activeRoutes = ['/fwp/massive_upload', '/fwp/catalog', 'fwp/users-management'];
        const shouldIntercept = activeRoutes.some(route => currentUrl.endsWith(route));
        if (shouldIntercept) {
            const modifiedReq = req.clone();

            return next.handle(modifiedReq).pipe(
                map(event => {
                    if (event instanceof HttpResponse) {
                        if (this.networkService.checkEnvironmentIsDev()) {
                            const data = JSON.parse(event.body?.body);
                            if (event.body.statusCode !== 200) {
                                throw new Error(data.error);
                            }
                            
                        return new HttpResponse({
                            body: data,
                            headers: event.headers,
                            status: event.status,
                            statusText: event.statusText,
                        });

                        }
                    }
                    return event;
                })
            );

        }

        return next.handle(req);
    }
}
